export const buildOnboardingInvitationLink = (token: string) => {
  const configuredBase =
    import.meta.env.VITE_ONBOARDING_BASE_URL || window.location.origin;
  const url = new URL(configuredBase, window.location.origin);
  url.searchParams.set("token", token);
  return url.toString();
};
